import { useMemo } from 'react'

import { ActionTablePath } from '../action-table/action-table'
import { useGetCustomerQuery, useGetEmployeeQuery, useGetTasksQueryQuery } from '../../../api/plamo-api'
import { Link, useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { CheckOutlined, HomeOutlined } from '@ant-design/icons'
import { IconAngleDownSolidFull, IconCircleRegularFull, IconAngleUpSolidFull, IconListCheckSolidFull } from '../../../icon'
import { useGetUserLightQuery } from '../../../api/auth-api'
import PlamoApiWithSaveNotifications from '../util/with-save-notification'
import dayjs from 'dayjs'

const { 
  useDeleteTaskWithSaveNotificationMutation
} = PlamoApiWithSaveNotifications; 

const ObjectNameCustomer = ({ task }) => {
  const { data: customer } = useGetCustomerQuery({ id: task.objectId }) as any;
  return <Link to={`/customer/${task.objectId}/tasks`}>{ customer?.firstName } { customer?.lastName }</Link>
}

const ObjectNameEmployee = ({ task }) => {
  const { data: employee } = useGetEmployeeQuery({ id: task.objectId }) as any;
  return <Link to={`/employee/${task.objectId}/tasks`}>{ employee?.firstName } { employee?.lastName }</Link>
}

const ObjectName = ({ task }) => {
  return <>
    { task.objectType === 'customer' && <ObjectNameCustomer task={task} /> }
    { task.objectType === 'employee' && <ObjectNameEmployee task={task} /> }
  </>
}

const AssignedUser = ({ id }) => {
  const { data: user } = useGetUserLightQuery({ id }) as any;
  return <>{ user?.usernameDisplay }</>
}

const TimestampPriority = ({ item }) => {
  const timestamp = item.timestamp ? dayjs(item.timestamp).format('DD.MM.YYYY') : '';

  const priority = useMemo(() => {
    if(item.priority === 1) return <IconAngleDownSolidFull />;
    if(item.priority === 3) return <IconCircleRegularFull />;
    if(item.priority === 5) return <IconAngleUpSolidFull />;
  }, [item.priority])

  return <>{timestamp} {priority}</>
}

const TaskDescription = ({ task }) => {
  const text = task.text?.substring(0, 100) + (task.text?.length > 100 ? '…' : '')
  const linkPlaceholders = text.match(/\[(.*?)\]/);
  console.log("Link placeholders", linkPlaceholders);
  let result
  if(task.link && linkPlaceholders) {
    const parts = text.split(linkPlaceholders[0])
    result = <>{ parts[0] || '' }<Link to={task.link}>{ linkPlaceholders[1] }</Link>{ parts[1] || '' }</>
  } else {
    result = <>{ text }</>
  }
  return result
}

function TasksListPage() {
  const navigate = useNavigate()
  const [deleteTask] = useDeleteTaskWithSaveNotificationMutation();
 
  const isLoading = false;
  
  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Status",
      dataIndex: 'solved',
      sorter: true,
      filter: true,
      render: value => value ? <CheckOutlined /> : <></>
    },
    {
      title: "Fällig / Priorität",
      dataIndex: "timestampPriority",
      sorter: true,
      filter: true,
      render: (_, item) => <TimestampPriority item={item} />
    },
    {
      title: "Objekttyp",
      dataIndex: "objectType",
      sorter: true,
      filter: true,
      type: 'string',
      render: value => value === 'customer' ? 'Kunde' : 'Mitarbeiter'
    },
    {
      title: "Objekt",
      dataIndex: "objectId",
      sorter: true,
      filter: true,
      type: 'string',
      render: (value, item) => <ObjectName task={item} />
    },
    {
      title: "Mitarbeiter",
      dataIndex: "assignedUserId",
      sorter: true,
      filter: true,
      type: 'string',
      render: (value) => <AssignedUser id={value} />
    },
    {
      title: "Beschreibung",
      dataIndex: "text",
      sorter: true,
      filter: true,
      type: 'string',
      render: (_, item) => <TaskDescription task={item} />
    }
  ], [])

  return (
    <div>
      <Breadcrumb
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              title: (
                <>
                  <IconListCheckSolidFull />
                  <span>Todos</span>
                </>
              ),
            },            
          ]}
        />
      <ActionTablePath
          isParentLoading={isLoading}
          buttonRow={{
            buttons: [
              {
                text: 'Neu',
                buttonType: 'primary',
                onClick: () => navigate('./new')
              },
            ]
          }}
          tableData={{
            defaultSortKey: 'id',
            columns,
            dataSource: {
              pageableQueryEndpoint: useGetTasksQueryQuery,
              queryResultMapping: (result) => result?.items
            },
            actions: [
              {
                caption: 'Löschen',
                danger: true,
                onClick: deleteTask,
                confirmTitle: _ => "Todo löschen?",
                confirmContent: _ => <>Soll das Todo wirklich gelöscht werden?</>  
              }
            ]
          }}
        />

    </div>
  )
}

export default TasksListPage